import fetch from "cross-fetch";

const { Plugin } = require("@uppy/core");

class UppyPresigned extends Plugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = opts.id || "MyPlugin";
    this.type = "example";
    this.prepareUpload = this.prepareUpload.bind(this); // ← this!
  }

  prepareUpload(fileIDs) {
    const promises = fileIDs.map((fileID) => {
      const file = this.uppy.getFile(fileID);
      // if (file.type.split('/')[0] !== 'image') {
      //   return
      // }
      // return this.compress(file.data).then((compressedBlob) => {
      //   const compressedFile = Object.assign({}, file, { data: compressedBlob })
      //   this.uppy.setFileState(fileID, compressedFile)
      // })
      return new Promise((resolve) => {
        fetch(`/api/media/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            metadata: file.meta,
          }),
        })
          .then((res) => {
            if (res.status >= 400) {
              throw new Error("Bad response from server");
            }
            return res.json();
          })
          .then((body) => {
            // console.log("response from created media:", body);
            let updatedFilemeta = Object.assign({}, file.meta, {
              mediaRand: body.rand,
            });
            // console.log("updatedFilemeta:", updatedFilemeta);
            this.uppy.setFileMeta(fileID, updatedFilemeta);
            resolve();
          })
          .catch((err) => {
            console.error("Fetch error:", err);
          });
      });
    });
    return Promise.all(promises);
  }

  install() {
    this.uppy.addPreProcessor(this.prepareUpload);
  }

  uninstall() {
    this.uppy.removePreProcessor(this.prepareUpload);
  }
}

export default UppyPresigned;
